import { Helmet } from 'react-helmet-async';

import classNames from 'classnames';

import styles from './WistiaElement.module.css';

import { useHasScrolled } from '../../../hooks';
import type { NativeWistiaOptions } from './types';

type IntrinsicDivProps = JSX.IntrinsicElements['div'];

export interface WistiaElementProps extends IntrinsicDivProps {
  id: string;
  options?: NativeWistiaOptions;
  deferMountUntilScroll: boolean;
}

/** Render a DIV element used by the wistia script to host the video. */
export function WistiaElement(props: WistiaElementProps) {
  const {
    options = { popover: false },
    id,
    className,
    deferMountUntilScroll = false,
    ...divProps
  } = props;

  const hasScrolled = useHasScrolled();

  if (deferMountUntilScroll && !hasScrolled) {
    return null;
  }

  const cssClass = classNames(
    {
      wistia_embed: true,
      [`wistia_async_${id}`]: true,
      [styles.wistiaElement]: true,
      [styles.popover]: options.popover,
      'popover=true': options.popover,
    },
    className
  );
  return (
    <>
      <Helmet>
        <script src="//fast.wistia.com/assets/external/E-v1.js" async></script>
      </Helmet>
      <div
        {...divProps}
        // We need to add a `key` so that the Wistia script detects when the `id` changes
        key={id}
        className={cssClass}
      />
    </>
  );
}
